/**
 * The Telegram account customers reach for help. Kept in sync with the server's
 * copy in server/src/core/constants.ts (SUPPORT_USERNAME).
 */
export const SUPPORT_USERNAME = 'cipher_me';
export const SUPPORT_URL = `https://t.me/${SUPPORT_USERNAME}`;
